module.exports = __webpack_public_path__ + "img/cx_a2b2.png";